var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#83858C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.52,20.58c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1c0.55,0,1,0.45,1,1C18.52,20.13,18.07,20.58,17.52,20.58  M6.48,20.58c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1c0.55,0,1,0.45,1,1C7.48,20.13,7.03,20.58,6.48,20.58 M17.88,14.56l2-3.46 c0.11-0.2,0.05-0.45-0.15-0.57c-0.2-0.11-0.45-0.05-0.57,0.15l-2.02,3.5c-1.55-0.71-3.28-1.1-5.14-1.1c-1.85,0-3.59,0.39-5.14,1.1 l-2.02-3.5c-0.11-0.2-0.37-0.27-0.57-0.15c-0.2,0.11-0.27,0.37-0.15,0.57l2,3.46C2.69,16.43,0.34,19.9,0,24h24 C23.66,19.9,21.31,16.43,17.88,14.56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAndroid);
export default __webpack_public_path__ + "static/media/icon-android.c3d2fb989f755c37c22c3d399a8102e0.svg";
export { ForwardRef as ReactComponent };